import Button from '../../../../components/Button';
import { formatUSD } from '../../../../helpers';
import useModalState from '../../../../context/modal/useModalState';
import useCancelOrder from '../../../../hooks/web3/trade/useCancelOrder';
import { OrderBookType } from '../../../../config/constants';

type ExistingTPSLProps = {
    label: string;
    amount: string;
    orderId: string;
    orderType: OrderBookType;
};

const ExistingTPSL: React.FC<ExistingTPSLProps> = ({
    amount,
    label,
    orderId,
    orderType,
}) => {
    const { closeModal } = useModalState();

    const cancel = useCancelOrder();

    const handleCancel = async () => {
        await cancel(orderId, orderType, () => closeModal('editPositionModal'));
    };

    return (
        <div className='existing-tpsl-container'>
            <div className='amount-container'>
                <div className='label'>{label}</div>
                <div className='amount'>
                    {formatUSD(amount, { minDecimals: 2, currency: '' })} USD
                </div>
            </div>
            <Button onClick={handleCancel}>
                Cancel{' '}
                {label
                    .split(' ')
                    .map((word) => word.charAt(0))
                    .join('')}
            </Button>
        </div>
    );
};

export default ExistingTPSL;
